module.exports = __webpack_public_path__ + "img/banner_xxsx.7938c96c.png";